/**
 * RTM — Retail Task Manager routes.
 *
 *   /rtm           → task list (My / Team / Unassigned tabs)
 *   /rtm/:taskId   → task detail
 */
import { Routes, Route } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import RtmDashboard from './index';
import { TaskDetail } from './TaskDetail';

export function RtmRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<RtmDashboard />} />
      <Route path=":taskId" element={<TaskDetail />} />
      <Route path="*" element={<SplatRedirect />} />
    </Routes>
  );
}
